import { render, staticRenderFns } from "./AtendimentoServicoDialog.vue?vue&type=template&id=e31fd278"
import script from "./AtendimentoServicoDialog.vue?vue&type=script&lang=js"
export * from "./AtendimentoServicoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports